export default "__VITE_ASSET__CjRR$57U__"